import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { User, UserRole } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private loggedInSubject = new BehaviorSubject<boolean>(false);
  isLoggedIn$: Observable<boolean> = this.loggedInSubject.asObservable();

  private currentUserSubject = new BehaviorSubject<User | null>(null);
  currentUser$: Observable<User | null> = this.currentUserSubject.asObservable();

  constructor(private router: Router) {
    // Check local storage for mock session
    const storedUser = localStorage.getItem('mockUser');
    if (storedUser) {
      this.currentUserSubject.next(JSON.parse(storedUser));
      this.loggedInSubject.next(true);
    }
  }

  login(email: string, password: string): boolean {
    if (email && password.length >= 6) {
      const role = email.includes('admin') ? UserRole.SUPER_ADMIN : UserRole.CALL_CENTER_AGENT;
      const mockUser: User = {
        id: 'u1',
        email: email,
        fullName: 'شريف أحمد',
        phone: '01000000000',
        role: role,
        avatarUrl: '',
        createdAt: new Date()
      };
      this.currentUserSubject.next(mockUser);
      this.loggedInSubject.next(true);
      localStorage.setItem('mockUser', JSON.stringify(mockUser));
      this.router.navigate(['/dashboard']);
      return true;
    }
    return false;
  }

  hasRole(roles: UserRole[]): boolean {
    const user = this.currentUserSubject.getValue();
    return user ? roles.includes(user.role) : false;
  }

  logout() {
    this.loggedInSubject.next(false);
    this.currentUserSubject.next(null);
    localStorage.removeItem('mockUser');
    this.router.navigate(['/login']);
  }
}
